import { format } from 'date-fns';
import React, { useContext } from 'react';
import toast from 'react-hot-toast';
import { AuthContext } from '../../../contexts/AuthProvider';

const BookingModal = ({ treatment, setTreatment, selectedDate,  refetch }) => {
    // treatment is just another name of appointmentOptions with name, slots, _id
    const { name, slots, price } = treatment;
    const date = format(selectedDate, "PP")
    const { user } = useContext(AuthContext);

    const handleBooking = event => {
        event.preventDefault()
        const form = event.target;
        const slot = form.slot.value;
        const patientName = form.patientName.value;
        const phone = form.phone.value;
        const email = form.email.value;

        const booking = {
            appointment: date,
            slot,
            treatment: name,
            patientName: patientName,
            phone,
            email,
            price,
        }
        // TODO: send data to the server
        // and once data is saved then close the modal
        // and display success toast

        // console.log(booking);

        fetch('https://doctors-portal-server-chi-two.vercel.app/bookings', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(booking)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                if (data.acknowledged) {
                    setTreatment(null)
                    toast.success('Booking confirmed')
                    refetch()
                }
                else{
                    toast.error(data.message);
                }
            })

    }

    return (
        <>
            <input type="checkbox" id="booking-modal" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box relative">
                    <label htmlFor="booking-modal" className="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                    <h3 className="text-lg font-bold">{name}</h3>
                    <form onSubmit={handleBooking} className='grid grid-cols-1 gap-3 mt-10'>
                        <input type="text" disabled value={date} className="input w-full border border-gray-100" />
                        <select name='slot' className="select select-bordered w-full">
                            {

                                slots.map((slot, i) => <option
                                    key={i}
                                    value={slot}
                                >{slot}</option>)
                            }
                        </select>
                        <input name='patientName' type="text" disabled defaultValue={user?.displayName} className="input w-full border border-gray-100" />
                        <input name='email' type="text" disabled defaultValue={user?.email} className="input w-full border border-gray-100" />
                        <input name='phone' type="text" placeholder="Phone Number" className="input w-full border border-gray-100" />
                        <input type="submit" value="Submit" className='btn btn-accent w-full' />
                    </form>
                </div>
            </div>
        </>
    );
};

export default BookingModal;